if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          button: this.querySelector('button'),
          panel: this.querySelector('.disclosure__list-wrapper'),
        };
        this.items = Array.from(this.querySelectorAll('.disclosure__list a'));

        this.elements.button.addEventListener('click', this.toggleSelector.bind(this));
        this.elements.button.addEventListener('keydown', this.onButtonKeyDown.bind(this));
        this.addEventListener('keydown', this.onContainerKeyDown.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));

        this.items.forEach((item) => {
          item.addEventListener('click', this.onItemClick.bind(this));
          item.addEventListener('keydown', this.onItemKeyDown.bind(this));
        });
      }

      isOpen() {
        return this.elements.button.getAttribute('aria-expanded') === 'true';
      }

      showPanel() {
        this.elements.panel.removeAttribute('hidden');
        this.elements.button.setAttribute('aria-expanded', 'true');
      }

      hidePanel() {
        this.elements.panel.setAttribute('hidden', '');
        this.elements.button.setAttribute('aria-expanded', 'false');
      }

      toggleSelector() {
        if (this.isOpen()) {
          this.hidePanel();
        } else {
          this.showPanel();
        }
      }

      focusItem(index) {
        if (this.items.length === 0) return;
        const wrapped = (index + this.items.length) % this.items.length;
        this.items[wrapped].focus();
      }

      onButtonKeyDown(event) {
        // ArrowDown/Up open the panel and focus the first/last item.
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          if (!this.isOpen()) this.showPanel();
          this.focusItem(event.key === 'ArrowDown' ? 0 : this.items.length - 1);
        }
      }

      onItemKeyDown(event) {
        const currentIndex = this.items.indexOf(event.currentTarget);
        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault();
            this.focusItem(currentIndex + 1);
            break;
          case 'ArrowUp':
            event.preventDefault();
            this.focusItem(currentIndex - 1);
            break;
          case 'Home':
            event.preventDefault();
            this.focusItem(0);
            break;
          case 'End':
            event.preventDefault();
            this.focusItem(this.items.length - 1);
            break;
        }
      }

      onContainerKeyDown(event) {
        if (event.key === 'Escape' && this.isOpen()) {
          event.stopPropagation();
          this.hidePanel();
          this.elements.button.focus();
        }
      }

      onFocusOut(event) {
        // Close when focus leaves the entire disclosure region.
        // relatedTarget is the new focus target, or null when leaving the document.
        if (event.relatedTarget && this.contains(event.relatedTarget)) return;
        this.hidePanel();
      }

      onItemClick(event) {
        event.preventDefault();
        const form = this.querySelector('form');
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }
    }
  );
}
